import { Form, FormikProvider, useFormik } from 'formik';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import { useTranslation } from 'react-i18next';
import { DeviceTag } from '../../@types/model/user';
import DeliveryConfigurationPicker from 'components/DeliveryConfigurationPicker';
import DeliveryConfigurationsPicker from '../../components/DeliveryConfigurationsPicker';
import { RootState, useSelector } from 'redux/store';
import { useState } from 'react';
import { checkWorkspace, WORKSPACES_INGAFOOD } from 'guards/CheckRoles';

export interface DeviceGroupFormProps {
  deviceGroup: DeviceTag;
  edit: boolean;
  submitHandler: (group: DeviceTag) => void;
}

type createOrUpdateDeviceGroupInitialValues = {
  name: string;
  type: string;
  shared: boolean;
  is_ref_of: boolean;
  delivery_configurations: string[];
};

const DeviceGroupForm = (props: DeviceGroupFormProps) => {
  const isMountedRef = useIsMountedRef();
  const { t } = useTranslation();
  const { deliveryConfigurations } = useSelector((state: RootState) => state.user);
  const [saving, setSaving] = useState<boolean | undefined>(false);
  const { workspace } = useSelector((state: RootState) => state.workspace);

  const createOrUpdateDeviceGroupShchema = Yup.object().shape({
    name: Yup.string().required(t('name_is_required'))
  });

  const CreateOrUpdateDeviceGroup = useFormik<createOrUpdateDeviceGroupInitialValues>({
    initialValues: {
      name: props.deviceGroup.attributes.name,
      shared: props.deviceGroup.attributes.shared,
      is_ref_of: props.deviceGroup.attributes.is_ref_of,
      type: props.deviceGroup.attributes.type,
      delivery_configurations: props.deviceGroup.attributes.delivery_configurations
    },
    validationSchema: createOrUpdateDeviceGroupShchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      setSaving(true);
      try {
        //await chagePassword(values.email, values.password, values.newPassword);
        props.submitHandler({
          guid: props.deviceGroup.guid,
          attributes: {
            type: values.type,
            name: values.name,
            shared: values.shared,
            is_ref_of: values.is_ref_of,
            device_count: 0,
            delivery_configurations: values.delivery_configurations,
            parent: '',
            owner: null
          }
        } as DeviceTag);
        if (isMountedRef.current) {
          setSubmitting(false);
        }
      } catch (error) {
        resetForm();
        if (isMountedRef.current) {
          setSubmitting(false);
          if (error.message === 'newPasswordRequired') {
            // setChangePasswordNeeded(true);
          } else {
            //setErrors({ afterSubmit: error.message });
          }
        }
      }
    }
  });
  return (
    <FormikProvider value={CreateOrUpdateDeviceGroup}>
      <Form autoComplete="off" noValidate onSubmit={CreateOrUpdateDeviceGroup.handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="nombre"
            type="string"
            label="Nombre"
            {...CreateOrUpdateDeviceGroup.getFieldProps('name')}
            error={Boolean(
              CreateOrUpdateDeviceGroup.touched.name && CreateOrUpdateDeviceGroup.errors.name
            )}
            helperText={
              CreateOrUpdateDeviceGroup.touched.name && CreateOrUpdateDeviceGroup.errors.name
            }
          />
          {checkWorkspace(workspace, WORKSPACES_INGAFOOD) && (
            <DeliveryConfigurationsPicker
              {...CreateOrUpdateDeviceGroup.getFieldProps('delivery_configurations')}
              deliveryConfigurationGuids={CreateOrUpdateDeviceGroup.values.delivery_configurations}
              changeHandler={(deliveryConfigurationGuids: string[] | null) => {
                CreateOrUpdateDeviceGroup.setFieldValue(
                  'delivery_configurations',
                  deliveryConfigurationGuids
                );
              }}
              deliveryConfigurationAvailable={deliveryConfigurations.map((dc) => {
                return dc.guid;
              })}
              deliveryConfigurations={deliveryConfigurations}
            />
          )}
        </Stack>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={saving}
          sx={{ my: 2 }}
        >
          {props.edit ? t('update') : t('add')}
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
};

export default DeviceGroupForm;
